module.exports = __webpack_public_path__ + "web/img/sign_in.087ebb7d.png";